import { render, staticRenderFns } from "./Strength.vue?vue&type=template&id=a4e1496c&scoped=true&"
import script from "./Strength.vue?vue&type=script&lang=js&"
export * from "./Strength.vue?vue&type=script&lang=js&"
import style0 from "./Strength.vue?vue&type=style&index=0&id=a4e1496c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e1496c",
  null
  
)

export default component.exports